<form [formGroup]="empresaForm" (ngSubmit)="submitForm()" novalidate>
    <div class="container">
        <div class="card">
            <header class="card__header">
                <h2 class="card__title">Editar empresa</h2>
            </header>

            <!-- grid principal -->
            <div class="card__body form-grid">
                <!-- Tipo de empresa -->
                <fieldset class="field-group col-1-2">
                    <legend class="field-group__legend">
                        Tipo de empresa
                        <span class="req">*</span>
                    </legend>
                    <div class="radio-group">
                        <label class="radio">
                            <input
                                type="radio"
                                formControlName="tipoEmpresa"
                                value="Natural" />
                            <span>Persona natural</span>
                        </label>
                        <label class="radio">
                            <input
                                type="radio"
                                formControlName="tipoEmpresa"
                                value="Juridica" />
                            <span>Persona jurídica</span>
                        </label>
                    </div>
                    <p
                        class="error"
                        *ngIf="showError('tipoEmpresa', 'required')">
                        Debe seleccionar el tipo de empresa.
                    </p>
                </fieldset>

                <!-- Tipo de producto -->
                <fieldset class="field-group col-1-2">
                    <legend class="field-group__legend">
                        Tipo de producto
                        <span class="req">*</span>
                    </legend>
                    <div class="chips chips--lg">
                        <button
                            type="button"
                            *ngFor="let opcion of opcionesProducto"
                            (click)="toggleProducto(opcion, $event)"
                            [class.chip--active]="
                                selectedProductos.includes(opcion)
                            "
                            class="chip chip--check">
                            <span class="chip__check">✓</span>
                            <span class="chip__label">{{
                                etiquetaProducto(opcion)
                            }}</span>
                        </button>
                    </div>
                    <p class="hint">Selecciona al menos uno.</p>
                    <p
                        class="error"
                        *ngIf="
                            selectedProductos.length === 0 &&
                            touched('tipo_producto_que_importa')
                        ">
                        El tipo de producto es obligatorio.
                    </p>
                </fieldset>

                <!-- Eslabón -->
                <fieldset class="field-group col-full">
                    <legend class="field-group__legend">
                        Eslabón
                        <span class="req">*</span>
                    </legend>
                    <div class="chips chips--lg">
                        <button
                            type="button"
                            *ngFor="let opcion of opcionesEslabon"
                            (click)="toggleEslabon(opcion, $event)"
                            [disabled]="isEslabonDisabled(opcion)"
                            [class.chip--active]="isSelectedEslabon(opcion)"
                            class="chip chip--check"
                            [attr.title]="
                                isEslabonDisabled(opcion)
                                    ? 'Primero selecciona Productor, Importador o Comercializador.'
                                    : null
                            "
                            [attr.aria-pressed]="isSelectedEslabon(opcion)">
                            <span class="chip__check">✓</span>
                            <span class="chip__label">{{ opcion }}</span>
                        </button>
                    </div>

                    <div class="selected-pills" *ngIf="selectedEslabon.length">
                        <span class="pill" *ngFor="let e of selectedEslabon">
                            {{ e }}
                            <button
                                type="button"
                                class="pill__x"
                                (click)="toggleEslabon(e, $event)"
                                [attr.aria-label]="'Quitar ' + e">
                                ×
                            </button>
                        </span>
                    </div>

                    <p class="hint">
                        Regla: para elegir
                        <b>Empacador</b>
                        o
                        <b>Envasador</b>
                        , primero selecciona
                        <i>Productor</i>
                        ,
                        <i>Importador</i>
                        o
                        <i>Comercializador</i>
                        .
                    </p>
                    <p
                        class="error"
                        *ngIf="
                            selectedEslabon.length === 0 && touched('eslabon')
                        ">
                        El tipo de eslabón es obligatorio.
                    </p>
                </fieldset>

                <!-- NIT + DV -->
                <div class="nit-row col-full">
                    <div class="field nit">
                        <label for="nit">
                            NIT empresa
                            <span class="req">*</span>
                        </label>
                        <input id="nit" type="text" formControlName="nit" />
                    </div>

                    <div class="dash" aria-hidden="true">–</div>

                    <div class="field">
                        <label for="digito_verificacion">
                            DV
                            <span class="req">*</span>
                        </label>
                        <input
                            id="digito_verificacion"
                            type="number"
                            formControlName="digito_verificacion" />
                        <p
                            class="error"
                            *ngIf="
                                showError('digito_verificacion', 'required')
                            ">
                            El dígito de verificación es obligatorio.
                        </p>
                        <p
                            class="error"
                            *ngIf="showError('digito_verificacion', 'pattern')">
                            Debe tener exactamente 1 número.
                        </p>
                    </div>
                </div>

                <div class="field">
                    <label for="razonSocial">
                        Nombre o razón social
                        <span class="req">*</span>
                    </label>
                    <input
                        id="razonSocial"
                        type="text"
                        formControlName="razonSocial"
                        (input)="toUpperCase($event, 'razonSocial')" />
                    <p
                        class="error"
                        *ngIf="showError('razonSocial', 'required')">
                        Campo obligatorio.
                    </p>
                </div>

                <div class="field">
                    <label for="telefono">
                        Teléfono
                        <span class="req">*</span>
                    </label>
                    <input
                        id="telefono"
                        type="tel"
                        formControlName="telefono"
                        maxlength="10"
                        placeholder="3001234567" />
                    <p class="error" *ngIf="showError('telefono', 'required')">
                        Campo obligatorio.
                    </p>
                    <p class="error" *ngIf="showError('telefono', 'pattern')">
                        Debe tener 10 dígitos.
                    </p>
                </div>

                <div class="field">
                    <label for="cargoDependencia">
                        Cargo/Dependencia de la persona responsable de la
                        información:
                        <span class="req">*</span>
                    </label>
                    <select
                        id="cargoDependencia"
                        formControlName="cargoDependencia">
                        <option [ngValue]="null" disabled>
                            Seleccione un cargo/dependencia
                        </option>
                        <option
                            *ngFor="let cargo of cargos"
                            [ngValue]="cargo.nombre">
                            {{ cargo.nombre }}
                        </option>
                    </select>
                </div>

                <div class="field">
                    <label for="responsableInformacion">
                        Nombre del responsable de la información / Representante
                        Legal
                        <span class="req">*</span>
                    </label>
                    <input
                        id="responsableInformacion"
                        type="text"
                        (input)="toUpperCase($event, 'responsableInformacion')"
                        formControlName="responsableInformacion" />
                    <p
                        class="error"
                        *ngIf="showError('responsableInformacion', 'required')">
                        Campo obligatorio.
                    </p>
                </div>

                <div class="field col-full">
                    <label for="correo_corporativo">
                        Correo electrónico del responsable de la información /
                        Representante Legal:
                        <span class="req">*</span>
                    </label>
                    <input
                        id="correo_corporativo"
                        type="email"
                        formControlName="correo_corporativo"
                        placeholder="empresa@dominio.com" />
                    <p
                        class="error"
                        *ngIf="showError('correo_corporativo', 'required')">
                        Campo obligatorio.
                    </p>
                    <p
                        class="error"
                        *ngIf="showError('correo_corporativo', 'email')">
                        Correo no válido.
                    </p>
                </div>
            </div>

            <footer class="card__footer">
                <button type="submit" class="btn btn--primary btn--lg">
                    Guardar y continuar
                </button>
            </footer>
        </div>
    </div>
</form>
